import { apiClient, FileInfo } from '@melio/javascript-sdk';

import { useModelApi, UseModelApiProps } from '../../core';
import { FileModel } from './types';

type UseFileProps = UseModelApiProps<FileInfo>;

export const useFile = (props: UseFileProps): FileModel => {
  const client = apiClient.files();

  const query = useModelApi({
    ...props,
    queryKey: 'file',
    queryFn: () => client.get(props.id as string),
  });

  const getOCRData = (id?: string) => client.getOCRData(id ?? (props.id as string));

  return {
    ...query,
    getOCRData,
  };
};
